export default __webpack_public_path__ + "static/media/image-board-study-ranking-n-w@2x.51c0b556.png";